import { useQuery } from '@tanstack/react-query'
import { DEFAULT_LOCALE } from 'messages'

export function useMessages(
  locale: string | undefined = DEFAULT_LOCALE,
  types: string[]
) {
  const [languageCode] = locale.split('-')

  async function fetcher(): Promise<Record<string, string>> {
    const promises = types.map((type) => {
      return import(`../messages/${type}/${languageCode}.json`).then(
        (module) => {
          return module.default
        }
      )
    })

    return Promise.all(promises).then((results) =>
      results.reduce((acc, cur) => ({ ...acc, ...cur }), {})
    )
  }

  return useQuery({
    queryKey: ['messages', languageCode],
    queryFn: fetcher,
    retry: false,
  })
}
